/** Franjas horarias de jornada (alineado con calendario de agenda). */
export const WORK_DAY_START = { hour: 7, minute: 30 };
export const WORK_DAY_END = { hour: 16, minute: 0 };

export const getWorkDayEndDate = (refDate = new Date()) => {
  const d = new Date(refDate);
  d.setHours(WORK_DAY_END.hour, WORK_DAY_END.minute, 0, 0);
  return d;
};

export const getWorkDayEndMs = (refDateMs) =>
  getWorkDayEndDate(new Date(refDateMs)).getTime();

export function getWorkTimeSlots(stepMinutes = 30) {
  const slots = [];
  let cursor = WORK_DAY_START.hour * 60 + WORK_DAY_START.minute;
  const end = WORK_DAY_END.hour * 60 + WORK_DAY_END.minute;

  while (cursor <= end) {
    const h = Math.floor(cursor / 60);
    const m = cursor % 60;
    slots.push(
      `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`,
    );
    cursor += stepMinutes;
  }

  return slots;
}

export const formatTimeForSelect = (timeStr) => {
  if (!timeStr) return '';
  return timeStr.length >= 5 ? timeStr.slice(0, 5) : timeStr;
};
